import {
    getNodeId, isResponseCode5xx,
    logOperationalMetric
} from "../../../util/Util";
import {
    LIDAR_ASSET_TYPE
} from "../../../util/Constants";
import {
    getSiteDevicesConnectivity
} from "../../../resources/AssetResource";
import {metricProcessName} from "./LidarOverviewNetworkAPI";

export async function fetchScanlessOfflineDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        deviceType: LIDAR_ASSET_TYPE,
        filters:[
            {connectivityFilterKey:"useCase",connectivityFilterValue:"SCANLESS"}],
    }
    const startTime = Date.now();
    const result = await getSiteDevicesConnectivity(request.nodeId, request.deviceType, request.filters);
    if (result.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getSiteDevicesConnectivity", true, false);
        dispatcher({type: "RECEIVE_DATA", data: result.data});
    } else {
        const isFault = isResponseCode5xx(result.status)
        logOperationalMetric(startTime, metricProcessName, "getSiteDevicesConnectivity", false, isFault);
        dispatcher({type: "RECEIVE_DATA", data: {deviceConnectivityList: []}});
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/network/LidarManageByExceptionsNetworkAPI.js